import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { formatLength as l } from "../../_utils/css/format-length.js";
import $ from "../../_internal/icon/src/Icon.js";
import R from "../../_internal/icons/Success.js";
import S from "../../_internal/icons/Error.js";
import B from "../../_internal/icons/Warning.js";
import b from "../../_internal/icons/Info.js";
import { defineComponent as C, computed as a, h as r } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const x = {
  success: r(R, null),
  error: r(S, null),
  warning: r(B, null),
  info: r(b, null)
}, F = C({
  name: "ProgressLine",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    percentage: {
      type: Number,
      default: 0
    },
    railColor: String,
    railStyle: [String, Object],
    fillColor: [String, Object],
    status: {
      type: String,
      required: !0
    },
    indicatorPlacement: {
      type: String,
      required: !0
    },
    indicatorTextColor: String,
    unit: {
      type: String,
      default: "%"
    },
    processing: {
      type: Boolean,
      required: !0
    },
    showIndicator: {
      type: Boolean,
      required: !0
    },
    height: [String, Number],
    railBorderRadius: [String, Number],
    fillBorderRadius: [String, Number]
  },
  setup(e, {
    slots: o
  }) {
    const d = a(() => l(e.height)), f = a(() => {
      var t, n;
      return typeof e.fillColor == "object" ? `linear-gradient(to right, ${(t = e.fillColor) === null || t === void 0 ? void 0 : t.stops[0]} , ${(n = e.fillColor) === null || n === void 0 ? void 0 : n.stops[1]})` : e.fillColor;
    }), h = a(() => e.railBorderRadius !== void 0 ? l(e.railBorderRadius) : e.height !== void 0 ? l(e.height, {
      c: 0.5
    }) : ""), m = a(() => e.fillBorderRadius !== void 0 ? l(e.fillBorderRadius) : e.railBorderRadius !== void 0 ? l(e.railBorderRadius) : e.height !== void 0 ? l(e.height, {
      c: 0.5
    }) : "");
    return () => {
      const {
        indicatorPlacement: t,
        railColor: n,
        railStyle: v,
        percentage: u,
        unit: c,
        indicatorTextColor: s,
        status: g,
        showIndicator: y,
        processing: p,
        clsPrefix: i
      } = e;
      return r("div", {
        class: `${i}-progress-content`,
        role: "none"
      }, r("div", {
        class: `${i}-progress-graph`,
        "aria-hidden": !0
      }, r("div", {
        class: [`${i}-progress-graph-line`, {
          [`${i}-progress-graph-line--indicator-${t}`]: !0
        }]
      }, r("div", {
        class: `${i}-progress-graph-line-rail`,
        style: [{
          backgroundColor: n,
          height: d.value,
          borderRadius: h.value
        }, v]
      }, r("div", {
        class: [`${i}-progress-graph-line-fill`, p && `${i}-progress-graph-line-fill--processing`],
        style: {
          maxWidth: `${e.percentage}%`,
          background: f.value,
          height: d.value,
          lineHeight: d.value,
          borderRadius: m.value
        }
      }, t === "inside" ? r("div", {
        class: `${i}-progress-graph-line-indicator`,
        style: {
          color: s
        }
      }, o.default ? o.default() : `${u}${c}`) : null)))), y && t === "outside" ? r("div", null, o.default ? r("div", {
        class: `${i}-progress-custom-content`,
        style: {
          color: s
        },
        role: "none"
      }, o.default()) : g === "default" ? r("div", {
        role: "none",
        class: `${i}-progress-icon ${i}-progress-icon--as-text`,
        style: {
          color: s
        }
      }, u, c) : r("div", {
        class: `${i}-progress-icon`,
        "aria-hidden": !0
      }, r($, {
        clsPrefix: i
      }, {
        default: () => x[g]
      }))) : null);
    };
  }
});
export {
  F as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/progress/src/Line.js
// module id = 1730
// module chunks = 67